import { Box, Flex, Text, TextButton, TextLink } from '@modusign/design-system';

import CenterLoadingSpinner from '@app/components/CenterLoadingSpinner';

interface AddressBookSearchStatusMessageProps {
  count: number;
  hasMore: boolean;
  searchKeyword: string;
  status: 'error' | 'idle' | 'loading' | 'success';
  totalCount: number;
  onFetchMore: () => void;
  onRetry: () => void;
}

export default function AddressBookSearchStatusMessage({
  count,
  hasMore,
  searchKeyword,
  status,
  totalCount,
  onFetchMore,
  onRetry,
}: AddressBookSearchStatusMessageProps) {
  return (
    <>
      {status === 'success' && totalCount === 0 && (
        <Flex alignItems="center" as="li" height="168px" justifyContent="center">
          <Text as="p" data-testid="address-book-search-result-message" textAlign="center">
            {`'${searchKeyword}'`} 검색 결과가 없습니다.
            <br />
            <TextLink
              className="tagCreateAddressButtonInSearchResult"
              href="/settings/address-book"
              rel="noopener noreferrer"
              target="_blank"
            >
              새 연락처 추가하기
            </TextLink>
          </Text>
        </Flex>
      )}
      {status === 'success' && hasMore && (
        <TextButton
          sx={{
            mb: 6,
            py: 6,
            width: '100%',
          }}
          onClick={onFetchMore}
        >
          스크롤하여 더보기 {`(${count}/${totalCount})`}
        </TextButton>
      )}
      {status === 'loading' && (
        <Box as="li" height="90px" position="relative" py={4} textAlign="center">
          <CenterLoadingSpinner color="gray" size={20} />
        </Box>
      )}
      {status === 'error' && (
        <Flex
          alignItems="center"
          as="li"
          flexDirection="column"
          height="168px"
          justifyContent="center"
        >
          <Text as="p" mb={3} textAlign="center">
            {`'${searchKeyword}'`} 검색 결과를 불러오지 못했습니다.
          </Text>
          <TextButton
            sx={{
              py: 3,
              width: '100%',
            }}
            onClick={onRetry}
          >
            다시 시도
          </TextButton>
        </Flex>
      )}
    </>
  );
}
